import {LIMIT_PAGE_DEFAULT} from "@/shared/constant";
import {LadingErrorStatus} from "@/enums/status/ladingerror";

export class LadingErrorCustomerParams {
    page? = 1;
    limit? = LIMIT_PAGE_DEFAULT;
    search?: string;
    status? = LadingErrorStatus.ChoXuLy;
}